import TeamDirectoryPage from '../components/team/TeamDirectoryPage';

const Doctors = () => {
    return (
        <TeamDirectoryPage
            title="Equipa Técnica"
            activeTab="Equipa Técnica"
            roleFilters={['ACCOUNT_ADMIN', 'CLINIC_CARE_GIVER']}
            showAgendaShortcut
        />
    );
};

export default Doctors;
